import { render, staticRenderFns } from "./CaseWorkbench.vue?vue&type=template&id=31da65a7"
import script from "./CaseWorkbench.vue?vue&type=script&lang=js"
export * from "./CaseWorkbench.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports